import { Injectable } from '@angular/core';
declare var jquery: any;
declare var $: any;

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class ChosenSelectService {

  constructor() { }

  Render(){
        var config = {
          '.chosen-select': {
              disable_search_threshold: 10,
              width: "100%"
          },
          '.chosen-select-deselect': {
              allow_single_deselect: true,
              width: "100%"
          },
          '.chosen-select-no-single': {
              disable_search_threshold: 100,
              width: "100%"
          },
          '.chosen-select-no-single.no-search': {
              disable_search_threshold: 10,
              width: "100%"
          },
          '.chosen-select-no-results': {
              no_results_text: 'Oops, nothing found!'
          },
          '.chosen-select-width': {
              width: "95%"
          }
      }
      for (var selector in config) {
          if (config.hasOwnProperty(selector)) {
              $(selector).chosen(config[selector]);
          }
      }
  }
}
